export default __webpack_public_path__ + "static/media/logo-on-menu-opened.45d1ccf9.png";